// Auto-generated normalizer for table: CursoOpinion
export function cursoOpinionNormalize(row) {
  return {
    idCursoOpinion: row.idCursoOpinion ?? row.IdCursoOpinion ?? row['IdCursoOpinion'] ?? 0,
    idCurso: row.idCurso ?? row.IdCurso ?? row['IdCurso'] ?? 0,
    idEstudiante: row.idEstudiante ?? row.IdEstudiante ?? row['IdEstudiante'] ?? 0,
    opinion: row.opinion ?? row.Opinion ?? row['Opinion'] ?? '',
    fechaPublicacion: row.fechaPublicacion ?? row.FechaPublicacion ?? row['FechaPublicacion'] ?? null,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
